import React from 'react';
import { NavLink } from 'react-router-dom';

const items = [
  { to: '/', label: 'Home', icon: '🏠' },
  { to: '/rooms', label: 'Friend Rooms', icon: '🚪' },
  { to: '/leaderboard', label: 'Leaderboard', icon: '🏆' },
];

export default function PrimaryNav() {
  return (
    <nav aria-label="Primary navigation" className="jw-primary-nav">
      {items.map(({ to, label, icon }) => (
        <NavLink
          key={to}
          to={to}
          end={to === '/'}
          className={({ isActive }) => `jw-primary-nav__item${isActive ? ' is-active' : ''}`}
        >
          <span aria-hidden="true" className="jw-primary-nav__icon">{icon}</span>
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
